<style lang="scss" scoped>
.image-modal::v-deep .v--modal-box {
  border-radius: 5px;
  overflow: visible;
  display: inline-block;
  width: auto !important;
  transform: translateX(-50%);
  left: 50% !important;
}

img {
  display: block;
  border-radius: 5px;
  max-height: calc(100vh - 20px);
  max-width: calc(100vw - 40px);
}
</style>

<template>
  <modal
    class="image-modal"
    name="image-modal"
    height="auto"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen"
  >
    <img :src="image" @click="close" />
  </modal>
</template>

<script>
export default {
  data() {
    return {
      image: null
    };
  },
  methods: {
    beforeOpen(event) {
      this.image = event.params.image;
    },
    close() {
      this.$modal.hide("image-modal");
    }
  }
};
</script>
